<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        自动查岗
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <div class="common-page common-body">
      <div v-hasPermi="['monitor:check:autoquery']" class="common-page common-tool-bar">
        <div class="btn" @click="searchDia = true"><i class="icon-tr-search"></i>查询</div>

        <!-- <router-link class="btn ml20" to="/device/device-add"><i class="icon-tr-newly-added"></i>新增</router-link> -->
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column prop="c_number" label="单位编号" align="center"> </el-table-column>
          <el-table-column prop="c_name" align="center" label="单位名称"> </el-table-column>
          <el-table-column prop="device_code" align="center" label="设备编号"> </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope" v-hasPermi="['monitor:check:autoset']">
              <el-button size="mini" type="primary" @click="setOpen(scope.row.device_code)">设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" :page-size="params.limit || 10" @current-change="pageChange" :total="total"> </el-pagination>
    </div>

    <el-dialog title="设置自动查岗" :visible.sync="showDia" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="110px" :rules="rules">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="查岗时间" inline-message="">
              <el-button size="" type="primary" circle="" icon="el-icon-plus" @click="changeOne()"></el-button>
              <div class="mb10 mt10" v-for="(item, index) in time" :key="index">
                <el-col :span="9">
                  <el-time-select
                    v-model="item.starttime"
                    :clearable="false"
                    :picker-options="{
                      start: index > 0 && time[index - 1].endtime ? time[index - 1].endtime : '00:00',
                      step: '00:30',
                      end: '23:30',
                    }"
                    placeholder="开始时间"
                  >
                  </el-time-select>
                </el-col>

                <el-col :span="9">
                  <el-time-select
                    v-model="item.endtime"
                    :clearable="false"
                    :picker-options="{
                      start: !item.starttime || item.starttime == '23:30' ? '00:00' : item.starttime,
                      step: '00:30',
                      end: '23:30',
                    }"
                    placeholder="结束时间"
                  >
                  </el-time-select
                ></el-col>
                <el-col :span="3">
                  <el-button size="small" type="danger" @click="changeOne(index)">删除</el-button>
                </el-col>
              </div>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="查岗日期">
              <el-checkbox-group v-model="checkboxGroup1" size="mini">
                <el-checkbox size="mini" v-for="(item, index) of cities" :label="index + 1" :key="index">{{ item }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="btn-box">
          <div class="l-btn" @click="onSubmit">保存</div>
          <div class="l-btn ml20" @click="back">返回</div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="查询" :visible.sync="searchDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <!-- <el-input></el-input> -->
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="resetSearch" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAutoList, editUser } from '../../api/device';
import { get, post } from '@/utils/http.js';

export default {
  data() {
    return {
      list: [],
      params: { page: 1, limit: 10, c_name: '' },
      total: 0,
      searchDia: false,
      searchForm: this.$getForm('autoCheckQuery'),

      showDia: false,
      cities: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'],
      status: 0, //0编辑 1添加
      checkboxGroup1: [],
      value1: [],
      checkList: [],
      form: {
        date: '',
        device_code: '',
      },
      time: [{ starttime: '00:00', endtime: '23:30' }],
      rules: {},
      remoteFuncs: {},
      editData: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleCheckAllChange(val) {
      //    console.log(val)
      this.checkedCities = val ? checkList : [];
    },
    changeOne(index) {
      //   console.log(index)
      if (index == undefined && this.time.length >= 5) {
        this.$message.warning('最多设置查岗五条');
        return;
      }
      if (index >= 0 && this.time.length <= 1) {
        this.$message.warning('请设置至少一个时间段');
        return;
      }
      index >= 0 ? this.time.splice(index, 1) : this.time.push({ starttime: '', endtime: '' });
    },
    setOpen(id) {
      this.reset();
      this.showDia = true;
      this.$post('/queryjob/queryjobdetail', { device_code: id }).then((res) => {
        // console.log(res)
        if (res.data.time) {
          this.status = 1;
          var { device_code, time, date } = res.data;
          this.form = { device_code, date };
          time.map((item, index) => {
            item.starttime = item.starttimeold;
          });
          this.time = time;
          //   this.checkboxGroup1 = date.split(',')
          var arr1 = date.split(',');
          // console.log(arr1)
          for (var i = 0; i < arr1.length; i++) {
            this.checkboxGroup1.push(Number(arr1[i]));
          }

          return;
        }
        this.status = 0;
        this.form.device_code = id;
      });
    },
    getList() {
      getAutoList(this.params)
        .then((res) => {
          this.list = res.data.list;
          this.total = res.data.count;
        })
        .catch((err) => {});
    },
    onSubmit() {
      this.showDia = false;
      this.dealData();

      this.save();
    },
    pageChange(index) {
      // console.log(params);
      this.params.page = index;
      this.getList();
    },
    dealData() {
      // console.log(this.checkboxGroup1)
      function numchan(number) {
        var arr2 = number.split(':');
        var num = arr2[0] + arr2[1];
        return Number(num);
      }
      function ten(num) {
        var e = num > 9 ? String(num) : '0' + num;
        return e;
      }
      function ran(min, max) {
        if (min > max) {
          var a = max;
          max = min;
          min = a;
        }
        var num = Math.floor(Math.random() * (max - min) + min);
        var num1 = parseInt(num / 100);
        var num0 = num % 100;
        if (num0 > 59) {
          num0 = 59;
        }
        var numAll = num1 + ten(num0);
        numAll = Number(numAll) >= 1000 ? numAll : '0' + numAll;
        var ar = numAll.split('');
        ar.splice(2, '', ':');
        numAll = ar.join('');

        return numAll;
      }
      var data = this.checkboxGroup1.join(',');
      this.form.date = data;
      var timArr = this.time;
      timArr.map((item, index) => {
        item.starttimeold = item.starttime;
        item.starttime = ran(numchan(item.starttime), numchan(item.endtime));
      });
      this.form.time = timArr;
    },
    save() {
      var api = this.status ? '/queryjob/updateinfo' : '/queryjob/addinfo';
      this.$post(api, { ...this.form, time: this.time })
        .then((res) => {
          // console.log(res)
          this.$message({
                message: '保存成功',
                type: 'success',
                duration: 700,
              });
          // this.$message.success('保存成功');
          this.reset();
        })
        .catch((err) => {});
    },
    reset() {
      var form = {
        time: [{ starttime: '00:00', endtime: '23:30' }],
        date: '',
        device_code: '',
      };
      this.form = form;
      this.checkboxGroup1 = [];
    },
    back() {
      this.reset();
      this.showDia = false;
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          console.log(data);
          this.params = { ...this.params, ...data };
          this.getList();
          this.params.page = 1;

          this.searchDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.searchDia = false;
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.mb10 {
  height: 40px;
  margin-bottom: 10px;
}
</style>
